import { CustomerAddressModel } from "../models";
import Select, { SingleValue } from "react-select";
import { useAuth } from "../hooks";
import Skeleton from "react-loading-skeleton";
import { useSavedAddresses } from "../hooks/useSavedAddresses";

type Props = {
  handleChange: (option: CustomerAddressModel) => void;
};

type AddressOption = {
  value: CustomerAddressModel["id"];
  label: string;
};

const SavedAddressOptions: React.FC<Props> = ({ handleChange }) => {
  const { customerId, isLoggedIn, isGuest } = useAuth();

  const enabled = Boolean(isLoggedIn && !isGuest && customerId);

  const {
    data: addresses = [],
    isLoading,
    isError,
  } = useSavedAddresses(customerId, enabled);

  const options: AddressOption[] = addresses.map((address) => ({
    value: address.id,
    label: [
      address.address_street,
      address.city_name,
      address.state_code,
      address.zip_code,
    ]
      .filter(Boolean)
      .join(", "),
  }));

  const handleSelection = (option: SingleValue<AddressOption>) => {
    if (!option) {
      return;
    }

    const selectedAddress = addresses.find(
      (address) => address.id === option.value,
    );

    if (selectedAddress) {
      handleChange(selectedAddress);
    }
  };

  if (isLoading) {
    return <Skeleton height={38} className="mb-5" />;
  }

  if (!enabled || isError || addresses.length === 0) {
    return (
      <div
        className="text-muted border border-secondary border-3 text-center p-3 rounded mb-2"
        style={{ borderStyle: "dashed !important" }}
      >
        No saved addresses available.
      </div>
    );
  }

  return (
    <>
      <Select
        className="mb-5"
        placeholder="Please select an address to continue"
        options={options}
        onChange={handleSelection}
        menuShouldScrollIntoView={false}
      />
    </>
  );
};

export default SavedAddressOptions;
